export const usmle2SurgeryModule = {
  id: "surgery",
  title: "Surgery",
  sections: [
    {
      type: "text",
      content:
        "Acute abdomen: stabilize, NPO, IV fluids, analgesia; emergent surgery for peritonitis.",
    },
    {
      type: "question",
      text: "Rigid abdomen with rebound tenderness suggests:",
      options: ["Irritable bowel", "Peritonitis", "GERD", "Cystitis"],
      correct: 1,
      explanation: "Peritonitis presents with guarding and rebound.",
    },
  ],
};
